export default async function CreateTaskApi(
  id, 
  name, 
  targetDate, 
  startDate, 
  assignTo, 
  clickUpData = null
) {
  let res = "";
  try {
    const body = {
      name: name,
      completionStatus: false,
      planId: id,
      taskEndDate: targetDate,
      taskStartDate: startDate || null,
      assignedTo: assignTo || null,
    };

    // Add ClickUp fields if provided
    if (clickUpData) {
      body.clickupSpaceId = clickUpData.spaceId || null;
      body.clickupListId = clickUpData.listId || null;
      body.clickupAssigneeId = clickUpData.assigneeId || null;
      body.clickupPriority = clickUpData.priority || null;
      body.clickupTags = clickUpData.tags || null;
    }

    const token = "Bearer " + localStorage.getItem("authToken");
    const requestOptions = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        accept: "application/json",
        Authorization: token,
      },
      body: JSON.stringify(body),
    };
    await fetch(`${process.env.REACT_APP_API_URL}v1/tasks/task`, requestOptions)
      .then((response) => response.json())
      .then((response) => {
        res = response;
      })
      .catch((error) => {
        console.error("Error: ", error);
        res = error;
      });
  } catch (error) {
    console.error(error);
    res = error;
  }

  return res;
}
